import { Info } from "lucide-react";

export function InfoTip({ text, className = "" }) {
  return (
    <span className={`relative inline-flex group/tip align-middle ${className}`} data-testid="info-tip">
      <Info size={13} className="cursor-help text-[#84675B] hover:text-[#4E342E] transition-colors" />
      <span className="pointer-events-none hidden group-hover/tip:block absolute left-1/2 -translate-x-1/2 top-full z-[97] mt-1.5 w-64 max-w-[80vw] rounded-xl border border-[#EFEBE0] bg-white p-2.5 text-left text-[11px] font-normal normal-case tracking-normal leading-relaxed text-[#5D4037] shadow-xl">
        {text}
      </span>
    </span>
  );
}
